import { DefaultPrimaryButton } from '@frontend/components/common';
import { DefaultModal, ModalType } from '@frontend/components/kiosk';
import { CommonMessage } from '@frontend/lang';
import { LuX } from 'react-icons/lu';
import { useIntl } from 'react-intl';

export interface NamePromptModalProps {
    id: string;
    show: boolean;
    value: string;
    isSubmitting: boolean;
    title: React.ReactNode;
    placeholder: string;
    onChange: (value: string) => void;
    onClose: () => void;
    onSubmit: () => void;
}

export const NamePromptModal = (props: NamePromptModalProps) => {
    const intl = useIntl();
    const canSubmit = props.value.trim().length > 0 && !props.isSubmitting;

    return (
        <DefaultModal
            id={props.id}
            handleClose={props.onClose}
            show={props.show}
            type={ModalType.PROMPT}
            className='bg-background-surface m-12 overflow-hidden rounded-2xl p-6'>
            <div className='flex flex-col items-stretch justify-start gap-6'>
                <div className='flex h-6 items-start justify-between self-stretch'>
                    <div className='text-foreground-default text-xl font-semibold'>{props.title}</div>
                    <button
                        type='button'
                        className='relative flex size-6 cursor-pointer items-center justify-center overflow-hidden'
                        onClick={props.onClose}
                        aria-label={intl.formatMessage({
                            id: 'Buttons.CLOSE',
                            defaultMessage: 'Close',
                            description: 'Close text on a button'
                        })}>
                        <LuX className='text-foreground-default size-6' />
                    </button>
                </div>
                <input
                    id={`${props.id}-input`}
                    autoFocus
                    autoComplete='off'
                    spellCheck={false}
                    inputMode='text'
                    disabled={props.isSubmitting}
                    value={props.value}
                    placeholder={props.placeholder}
                    onChange={(event) => props.onChange(event.target.value)}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter' && canSubmit) {
                            props.onSubmit();
                        }
                    }}
                    className='bg-background-surface outline-border-default h-11 w-full rounded-xl px-4 text-base font-medium outline-1 outline-offset-[-1px]'
                />
                <div className='flex items-start justify-end self-stretch'>
                    <DefaultPrimaryButton
                        text={CommonMessage.BUTTONS.SUBMIT}
                        onClick={props.onSubmit}
                        disabled={!canSubmit}
                        isLoading={props.isSubmitting}
                    />
                </div>
            </div>
        </DefaultModal>
    );
};
